import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=5fff9c18&scoped=true&"
import script from "./timer.vue?vue&type=script&lang=js&"
export * from "./timer.vue?vue&type=script&lang=js&"
import style0 from "./timer.vue?vue&type=style&index=0&id=5fff9c18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff9c18",
  null
  
)

export default component.exports